import {isCopilot} from '@github-ui/assignees/copilot-user'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {Link} from '@primer/react'

export function TimelineAvatar({user}: {user: {displayLogin: string; avatarUrl: string} | null}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const login = user?.displayLogin
  if (!login) return null

  const isAI = isCopilot(login)
  const profileUrl = isAI ? `/${'apps/'}` : user?.avatarUrl
  const hovercardAttributes = isAI
    ? getHovercardAttributesForType('copilot', {botSlug: login})
    : getHovercardAttributesForType('user', {login})

  return (
    <Link href={profileUrl} {...hovercardAttributes} aria-label={`${login}'s profile`} className="mr-1">
      <GitHubAvatar src={profileUrl} size={12} />
    </Link>
  )
}
